__turbopack_context__.v({
  "dialogTitle": "yhQHCW_dialogTitle",
  "faqContainer": "yhQHCW_faqContainer",
  "faqContentWrapper": "yhQHCW_faqContentWrapper",
  "faqItem": "yhQHCW_faqItem",
  "faqList": "yhQHCW_faqList",
});
